import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { SectionLabel } from '../components/SectionLabel';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { AudioTestimonial } from '../components/AudioTestimonial';
import { ReviewForm } from '../components/ReviewForm';
const testimonialsData = [{
  name: 'Sarah M. — Phoenix, AZ',
  rating: 5,
  review: "I used this in my car after a terrible meeting. I was shaking. Within a minute I could actually breathe again. I don't know how it works but it does. Every woman needs this.",
  avatarUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80'
}, {
  name: 'Diana R. — Miami, FL',
  rating: 4.5,
  review: "I was skeptical because I've tried everything. But at $6 I figured why not. The action cards are what got me. I have them saved to my phone and I've used them 4 times this week already. The road rage one works like a switch.",
  avatarUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&q=80'
}, {
  name: 'Patricia L. — Chicago, IL',
  rating: 5,
  review: 'I snapped at my daughter one too many times. I was desperate. This guide took me 20 minutes to read and I used the technique that same evening. For the first time in years I felt like I was in control of myself.',
  avatarUrl: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&q=80'
}, {
  name: 'Jasmine T. — Houston, TX',
  rating: 4,
  review: "Honestly didn't expect much. But the breathing sequence is legit. I use it before difficult phone calls now and it's changed how people respond to me. More calm = more powerful.",
  avatarUrl: 'https://images.unsplash.com/photo-1531123897727-8f129e1bfa82?w=150&q=80'
}, {
  name: 'Monica V. — Los Angeles, CA',
  rating: 5,
  review: "I've spent hundreds on therapy. This $6 guide gave me a tool I actually use in real life in real moments. Nothing else has ever done that.",
  avatarUrl: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=150&q=80'
}];
export function TestimonialsSection() {
  return <section className="py-14 md:py-20 px-6 bg-midnight overflow-hidden" data-id="element-450">
      <div className="max-w-6xl mx-auto" data-id="element-451">
        <FadeIn className="text-center mb-16" data-id="element-452">
          <SectionLabel text="Women Who Finally Found Their Off Switch" data-id="element-453" />
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-warmwhite" data-id="element-454">
            Real Results. Real Women. Real Relief.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-455">
          <AudioTestimonial data-id="element-456" />
        </FadeIn>

        <FadeIn delay={0.4} className="mb-24" data-id="element-457">
          <TestimonialCarousel testimonials={testimonialsData} data-id="element-458" />
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-459">
          <div className="text-center mb-8" data-id="element-460">
            <h3 className="font-inter text-rosegold font-medium text-lg" data-id="element-461">
              Already tried it? We'd love to hear from you.
            </h3>
          </div>
          <ReviewForm data-id="element-462" />
        </FadeIn>
      </div>
    </section>;
}